import { useRef } from 'react';

import { InputFieldSize } from '@xemplo/input-utils';
import { ListItem, SelectionMode, SelectionStyle } from '@xemplo/listbox';

import { useMultiStateV2 } from '../hooks/use-multi-state-v2';

import { BaseTextDropdownMultiProps } from './text-dropdown-multi-v2.types';
import { useDropdownStyle } from './use-dropdown-style';

export function useDropdownMulti<T extends ListItem>(
  props: BaseTextDropdownMultiProps<T>
) {
  const { displayProps, isDropdownMulti = true } = props;
  const containerRef = useRef<HTMLDivElement>(null);
  const listRef = useRef<HTMLUListElement>(null);
  const selectRef = useRef<HTMLSelectElement | null>(null);
  const singleValueRef = useRef<HTMLDivElement | null>(null);

  const { inputSize = InputFieldSize.Standard, isReadOnly } = displayProps ?? {};
  const multiState = useMultiStateV2({
    originalProps: props,
    containerRef,
    selectRef,
    listRef,
    singleValueRef,
  });

  const styling = useDropdownStyle({
    ...props,
    popoverIsOpen: multiState.popoverState.isOpen,
    listStateIsEmpty: multiState.listState.selectionManager.isEmpty,
  });

  return {
    ...styling,
    multiState,
    canShowOptionalLabel: inputSize === InputFieldSize.Large && !isReadOnly,
    selectionMode: isDropdownMulti ? SelectionMode.Multiple : SelectionMode.Single,
    selectionStyle: isDropdownMulti ? SelectionStyle.Checkbox : SelectionStyle.Highlight,
    containerRef,
    selectRef,
    singleValueRef,
    listRef,
  };
}
